module.exports = __webpack_public_path__ + "listening-target.cb1d504dc6bc5c264b8d0c9d4f167453.hashedasset.svg";